import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { useBuildingDetailQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — LL97 filing wizard is one of the heaviest non-chat
// surfaces (pdf-lib + the multi-step wizard tree). Lazy-loaded so the
// wizard payload only downloads when a filer actually opens the route.
const LL97SubmissionPage = lazy(
  () => import("@/pages/Filings/LL97Submission/Filing/Page"),
);

const LL97SubmissionRoute = () => {
  const { buildingId, ll97SubmissionId } = Route.useParams();
  const { data } = useBuildingDetailQuery(buildingId);
  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader
        header={`${data?.name || "Building"} - LL97 Filing`}
        backLink={`/buildings/${buildingId}`}
      />
      <Suspense fallback={null}>
        <LL97SubmissionPage
          buildingId={buildingId}
          submissionId={ll97SubmissionId}
        />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute(
  "/buildings_/$buildingId/ll97_/$ll97SubmissionId/",
)({
  component: LL97SubmissionRoute,
});
